import { cn } from "../lib/utils";
import { formatLabel } from "../lib/format";

export function Semaforo({ value, className, ...rest }) {
  const map = {
    verde: { cls: "semaforo-verde", label: "Vigente" },
    amarillo: { cls: "semaforo-amarillo", label: "Próximo" },
    rojo: { cls: "semaforo-rojo", label: "Crítico" },
  };
  const s = map[value] || map.verde;
  return (
    <span
      data-testid={`semaforo-${value}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium",
        s.cls,
        className
      )}
      {...rest}
    >
      <span className={cn("h-1.5 w-1.5 rounded-full",
        value === "verde" && "bg-brand-green-600",
        value === "amarillo" && "bg-amber-500",
        value === "rojo" && "bg-red-600",
      )} />
      {s.label}
    </span>
  );
}

export function StatusBadge({ children, tone = "neutral" }) {
  const tones = {
    neutral: "bg-slate-100 text-slate-700 border border-slate-200",
    success: "semaforo-verde",
    warning: "semaforo-amarillo",
    danger: "semaforo-rojo",
    info: "bg-brand-orange-100 text-brand-orange-700 border border-brand-orange-200",
  };
  // Auto-format raw lowercase tokens like "rca", "ambiental", "en_proceso".
  const content = typeof children === "string" ? formatLabel(children) : children;
  return (
    <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", tones[tone])}>
      {content}
    </span>
  );
}

// EstadoBadge: chooses a tone automatically based on the estado value.
// Use across all entities so the same status always has the same color.
const ESTADO_TONES = {
  // Compromiso / RCA
  pendiente:   "bg-amber-100 text-amber-800 border border-amber-200",
  en_proceso:  "bg-sky-100 text-sky-800 border border-sky-200",
  cumplido:    "bg-brand-green-100 text-brand-green-800 border border-brand-green-200",
  incumplido:  "bg-red-100 text-red-800 border border-red-200",
  atrasado:    "bg-red-100 text-red-800 border border-red-200",
  cancelado:   "bg-slate-200 text-slate-700 border border-slate-300",
  // Project
  planificacion: "bg-indigo-100 text-indigo-800 border border-indigo-200",
  ejecucion:    "bg-sky-100 text-sky-800 border border-sky-200",
  pausado:      "bg-amber-100 text-amber-800 border border-amber-200",
  finalizado:   "bg-brand-green-100 text-brand-green-800 border border-brand-green-200",
  cerrado:      "bg-brand-green-100 text-brand-green-800 border border-brand-green-200",
};
export function EstadoBadge({ value }) {
  const tone = ESTADO_TONES[value] || "bg-slate-100 text-slate-700 border border-slate-200";
  return (
    <span className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize", tone)}>
      {formatLabel(value)}
    </span>
  );
}
